import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import HeaderAfter from '../parts/Header'
import HeaderBefore from '../../pre_login/parts/Header'
import Footer from '../parts/Footer'
import ApiSubHeader from '../parts/ApiSubHeader'
import * as MyAPI from '../../../utils/MyAPI'
import * as AbstructedApi from '../../../utils/AbstructedApi'
import * as UserActions from '../../../actions/UserActions'
import SyntaxHighlighter from 'react-syntax-highlighter';
import { a11yDark } from 'react-syntax-highlighter/dist/esm/styles/hljs'
import DocsSideBar from './DocsSideBar'
import * as Helper from '../../../utils/Helper'
import { Helmet } from "react-helmet";

// example of node 1
let code1_node = [
  "import axios from 'axios'",
  "",
  "let results_1 = await axios.post(\"<APIのエンドポイント>\", {",
  " audio_url: \"<音声ファイルのURL>\",",
  "}, {",
  " headers: {",
  "  'Accept': 'application/json',",
  "  'Authorization': \"<APIのキー>\",",
  " },",
  "})",
]
let code1_node_str = code1_node.join("\n")


// // example of curl 1
// let code1_curl = [
//   "curl --request POST --url <APIのエンドポイント> \\ ",
//   "  --header \"Authorization: <APIのキー> \\ ",
//   "  --header 'content-type: application/json'  --data '{\"audio_url\": \"<音声ファイルのURL>\"}'"
// ]
// let code1_curl_str = code1_curl.join("\n")

// example of curl 1
let code1_curl = [
  "curl --request POST --url <APIのエンドポイント> \\ ",
  "  --header \"Authorization: <APIのキー>\" \\ ",
  "  --header \"content-type: application/json\"  --data \"{\\\"audio_url\\\": \\\"<音声ファイルのURL>\\\"}\""
]
let code1_curl_str = code1_curl.join("\n")

// example of python 1
let code1_python = [
  "body = {",
  "    'audio_url': \"<音声ファイルのURL>\",",
  "}",
  "headers = {",
  "    'Accept': 'application/json',",
  "    'Authorization': \"<APIのキー>\",",
  "}",
  "res = requests.post(\"<APIのエンドポイント>\", headers=headers, json=body)",
  "json = res.json()",
]
let code1_python_str = code1_python.join("\n")

// response str
let response1 = [
  "{",
  "  \"status\": \"success\",",
  "  \"@type\": \"v2\",",
  "  \"results\": [",
  "    {",
  "      \"alternatives\": [",
  "        {",
  "          \"confidence\": 0.99,",
  "          \"transcript\": \"本日 の DNA 対 オリックス の 第 三 回戦\",",
  "          \"startTime\": 1.16,",
  "          \"endTime\": 5.18",
  "        }",
  "      ]",
  "    },",
  "    {",
  "      \"alternatives\": [",
  "        {",
  "          \"confidence\": 0.99,",
  "          \"transcript\": \"は 11 対 8 で DNA が 勝利 し まし た\",",
  "          \"startTime\": 5.239999999999999,",
  "          \"endTime\": 8.34",
  "        }",
  "      ]",
  "    },",
  "    {",
  "      \"alternatives\": [",
  "        {",
  "          \"confidence\": 0.99,",
  "          \"transcript\": \"ソト が ホーム ラン を 二 発 打っ て い ます\",",
  "          \"startTime\": 8.719999999999999,",
  "          \"endTime\": 12.579999999999998",
  "        }",
  "      ]",
  "    }",
  "  ]",
  "}",
]
let response1_str = response1.join("\n")

// example of node 2
let code2_node = [
  "import axios from 'axios'",
  "",
  "let audio_data = fs.readFileSync(\"<音声ファイルのパス>\")",
  "let audio_base64 = audio_data.toString('base64')",
  "",
  "let results_1 = await axios.post(\"<APIのエンドポイント>\", {",
  "  audio: audio_base64,",
  "}, {",
  "  headers: {",
  "    'Accept': 'application/json',",
  "    'Authorization': \"<APIのキー>\",",
  "  },",
  "})"
]
let code2_node_str = code2_node.join("\n")

// example of python 2
let code2_python = [
  "encoded_bytes = \"\"",
  "with open(\"<音声ファイルのパス>\", \"rb\") as audio_file:",
  "    encoded_bytes = base64.b64encode(audio_file.read())",
  "encoded_string = encoded_bytes.decode(\"utf-8\")",
  "",
  "body = {",
  "    'audio': encoded_string,",
  "}",
  "headers = {",
  "    'Accept': 'application/json',",
  "    'Authorization': \"<APIのキー>\",",
  "}",
  "res = requests.post(\"<APIのエンドポイント>\", headers=headers, json=body)",
  "json = res.json()",
]
let code2_python_str = code2_python.join("\n")

// DocsTop
const DocsTop = (props) => {

  let dispatch = useDispatch();

  let navigate = useNavigate();

  // user_state
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  })
  let user_state_createdAt = useSelector(state => {
    if (state.user && state.user.createdAt) {
      return state.user.createdAt
    } else {
      return ''
    }
  })
  let user_info = useSelector(state => {
    if (state.user && state.user.user_info) {
      return state.user.user_info
    } else {
      return ''
    }
  })


  // let login_token = useSelector(state => {
  //   if (state.user && state.user.login_token) {
  //     return state.user.login_token
  //   } else {
  //     return ''
  //   }
  // });

  let [loading, setLoading] = useState(false)
  let [lang, setLang] = useState("node")
  let [codeType1, setCodeType1] = useState(code1_node_str)
  let [codeType2, setCodeType2] = useState(code2_node_str)


  // componentDidMount
  useEffect(() => {
    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _firstScript = async () => {

    if (!login_token) {

      let _rtnObj = await Helper.loginWithToken()
      if (_rtnObj.status === true) {

        let _login_token = _rtnObj.token_params.login_token
        dispatch(UserActions.loginWithEmail(_rtnObj.token_params))

        return;
      } else {
        // redirect
        return;
      }
    }

    if (user_state_createdAt) {
      let diff = new Date().getTime() - user_state_createdAt.getTime()
      if ( diff < 60*60*1000 ) {

        return;
      }
    }

    let _rtnObj = await Helper.loginWithToken(login_token)

    if (_rtnObj.status === true) {

      // login ok
      dispatch(UserActions.loginWithEmail(_rtnObj.token_params))

    } else {

    }
  }

  // _changeLangNode
  let _changeLang = (_lang) => {
    setLang(_lang)
    if (_lang === "node") {
      setCodeType1(code1_node_str)
      setCodeType2(code2_node_str)
    } else if (_lang === "python") {
      setCodeType1(code1_python_str)
      setCodeType2(code2_python_str)
    } else if (_lang === "curl") {
      setCodeType1(code1_curl_str)
    }
  }

  return (
    <div>

      <Helmet>
        <meta charSet="utf-8" />
        <title>喋ラボの音声認識エンジンクラウド | ドキュメント | トップ</title>
        <meta name="description" content="喋ラボの音声認識エンジンクラウドのドキュメントのトップページです。" />
      </Helmet>


      {login_token ? (
        <HeaderAfter />
      ) : (
        <HeaderBefore />
      )}

      {/* main */}
      <Container fluid style={{
        // marginTop: 40,
      }}>

        <Row style={{
          // marginTop: 20,
          marginBottom: 20,
        }}>

          {/* side bar */}
          <DocsSideBar/>

          <Col md="9" xs="12">

            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <h1 style={{
                  fontSize: 26,
                }}>
                  クイックスタート
                </h1>
              </Col>
            </Row>

            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <p style={{
                  fontSize: 20,
                }}>
                  このページでは喋ラボの音声認識APIの使い方を簡単に紹介します。APIの使い方は大きく分けて2つあります。
                </p>
              </Col>
            </Row>

            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <h2 style={{
                  fontSize: 20,
                  fontWeight: 'bold',
                }}>
                  1. 音声ファイルをurlで指定する方法
                </h2>
              </Col>
            </Row>
            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <p>
                  音声ファイルが弊社サーバーからアクセス可能なパブリックな場所にある場合にご利用頂けます。
                </p>
              </Col>
            </Row>

            {/* code block */}
            <Row style={{
              marginTop: 20,
              paddingLeft: 12,
              paddingRight: 12,
            }}>
              <Col style={{
                backgroundColor: '#2B2B2B',
                paddingTop: 10,
                paddingBottom: 10,
                borderBottomColor: '#777777',
                borderBottomWidth: 1,
                borderBottomStyle: 'solid',
              }}>
                <span onClick={() => _changeLang("node")} style={{
                  fontSize: 14,
                  color: lang === "node" ? 'yellow' : '#eeeeee',
                  marginRight: 10,
                  cursor: 'pointer',
                }}>
                  Node
                </span>

                <span style={{
                  color: '#777777',
                  marginRight: 10,
                  marginRight: 10,
                }}>
                |
                </span>

                <span onClick={() => _changeLang("python")} style={{
                  fontSize: 14,
                  color: lang === "python" ? 'yellow' : '#eeeeee',
                  marginRight: 10,
                  marginRight: 10,
                  cursor: 'pointer',
                }}>
                  Python
                </span>

                <span style={{
                  color: '#777777',
                  marginRight: 10,
                  marginRight: 10,
                }}>
                |
                </span>

                <span onClick={() => _changeLang("curl")} style={{
                  fontSize: 14,
                  color: lang === "curl" ? 'yellow' : '#eeeeee',
                  marginRight: 10,
                  marginRight: 10,
                  cursor: 'pointer',
                }}>
                  CURL
                </span>

              </Col>
            </Row>
            <Row style={{
              marginBottom: 20,
            }}>
              <Col>
                <SyntaxHighlighter language="javascript" style={a11yDark} wrapLines={true}>
                  {codeType1}
                </SyntaxHighlighter>
              </Col>
            </Row>

            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <p style={{
                  fontSize: 20,
                }}>
                  実行すると以下のようなレスポンスが返ってきます。
                </p>
              </Col>
            </Row>

            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <SyntaxHighlighter language="javascript" style={a11yDark} wrapLines={true}>
                  {response1_str}
                </SyntaxHighlighter>
              </Col>
            </Row>


            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <h2 style={{
                  fontSize: 20,
                  fontWeight: 'bold',
                }}>
                  2. 音声ファイルをバイナリで送る方法
                </h2>
              </Col>
            </Row>
            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <p>
                  プライベートな音声ファイル等に最適です。
                </p>
              </Col>
            </Row>

            {/* code block for type 2 */}
            <Row style={{
              marginTop: 20,
              paddingLeft: 12,
              paddingRight: 12,
            }}>
              <Col style={{
                backgroundColor: '#2B2B2B',
                paddingTop: 10,
                paddingBottom: 10,
                borderBottomColor: '#777777',
                borderBottomWidth: 1,
                borderBottomStyle: 'solid',
              }}>
                <span onClick={() => _changeLang("node")} style={{
                  fontSize: 14,
                  color: lang === "node" ? 'yellow' : '#eeeeee',
                  marginRight: 10,
                  cursor: 'pointer',
                }}>
                  Node
                </span>

                <span style={{
                  color: '#777777',
                  marginRight: 10,
                  marginRight: 10,
                }}>
                |
                </span>

                <span onClick={() => _changeLang("python")} style={{
                  fontSize: 14,
                  color: lang === "python" ? 'yellow' : '#eeeeee',
                  marginRight: 10,
                  marginRight: 10,
                  cursor: 'pointer',
                }}>
                  Python
                </span>

              </Col>
            </Row>
            <Row style={{
              marginBottom: 20,
            }}>
              <Col>
                <SyntaxHighlighter language="javascript" style={a11yDark} wrapLines={true}>
                  {codeType2}
                </SyntaxHighlighter>
              </Col>
            </Row>
            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <p style={{
                  fontSize: 20,
                }}>
                  実行結果は1と同様です。
                </p>
              </Col>
            </Row>

          </Col>

          <Col md="1" xs="12" />

        </Row>

      </Container>

      <br/>

      {/* footer */}
      <Footer />

    </div>
  )
}

export default DocsTop
